/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { AnnotationSettingsComponent } from "../../components/workspace/annotation-settings/annotation-settings.component";
import { AnnotationSettingsInfo } from "../../models/annotation-settings";
import { PopupDialog } from "../popup-dialog.interface";

export class AnnotationSettingsDialog implements PopupDialog {

    create(sysquePopupConfig: any): any {
        sysquePopupConfig.component = AnnotationSettingsComponent;
        sysquePopupConfig.data = new AnnotationSettingsInfo();
        (sysquePopupConfig.data as AnnotationSettingsInfo).discardButtonName = "Discard";
        (sysquePopupConfig.data as AnnotationSettingsInfo).saveButtonName = "Save";
        (sysquePopupConfig.data as AnnotationSettingsInfo).applyToSelectionButtonName = "Apply to Selection";
        sysquePopupConfig.width = 1490;
        sysquePopupConfig.height = 843;
        sysquePopupConfig.componentTitle = "Annotation Settings";
    }
}